import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { desktop } from '../../styles';
import { Component as StaticIcon } from '../StaticIcon';

const LeftNavWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;
const LeftNavLink = styled.a`
  display: flex;
`;

const NavSpacer = styled.div`
  display: flex;
  flex: 1;
`;

const BackIconWrapper = styled.div`
  margin-right: 4px;
  margin-top: 2px;
  color: ${({ theme }) => theme.colors.default};

  display: flex;
  align-items: center;
`;

const BackLabelWrapper = styled.div`
  color: ${({ theme }) => theme.colors.white};
  margin: auto 0;
  padding-left: 4px;
  ${({ theme }) => theme.paragraph.variants.paragraph4Uppercase.textStyles}
`;

const QuizNavBarWrapper = styled.div`
  display: flex;
  position: absolute;
  margin-top: ${({ theme }) => theme.spacing.small}px;
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing.small}px;
  z-index: 2;
  transition: color 400ms ease-in 100ms;

  @media (min-width: ${({ theme }) => theme.breakpoints.large}px) {
    margin-top: ${({ theme }) => theme.spacing.small}px;
  }

  & * {
    color: ${({ theme, navigationTextColor }) =>
      navigationTextColor || theme.colors.white};
  }
`;

const RightNavLink = styled.a`
  width: 100%;
  color: ${({ theme }) => theme.colors.default};

  ${({ theme }) => theme.paragraph.variants.paragraph4Uppercase.textStyles}
  margin: auto 0;
  padding-left: 4px;
`;

const RightNavButtonWrapper = styled.div`
  display: flex;
  cursor: pointer;
  width: 100px;
  text-align: right;
  justify-content: flex-end;

  ${desktop`
    width: unset;
  `};
`;

const StyledLeftChevron = styled(StaticIcon).attrs({
  type: 'caret',
  size: 8,
})`
  transform: rotate(90deg);
`;

const QuizNavBar = ({
  previousScreen,
  handleSkipQuiz,
  handleExit,
  shouldShowCloseLink,
  shouldShowSkipQuizLink,
  navigationTextColor,
  shouldShowBackLink,
}) => {
  return (
    <QuizNavBarWrapper navigationTextColor={navigationTextColor}>
      <LeftNavWrapper>
        <LeftNavLink onClick={previousScreen}>
          {shouldShowBackLink ? (
            <>
              <BackIconWrapper>
                <StyledLeftChevron />
              </BackIconWrapper>
              <BackLabelWrapper>
                <FormattedMessage
                  id="global_quiz.back_label"
                  defaultMessage="Back"
                />
              </BackLabelWrapper>
            </>
          ) : null}
        </LeftNavLink>
      </LeftNavWrapper>
      <NavSpacer />
      <RightNavButtonWrapper>
        {shouldShowCloseLink ? (
          <RightNavLink onClick={handleExit}>
            <StaticIcon type="close" size={16} />
          </RightNavLink>
        ) : null}
        {shouldShowSkipQuizLink ? (
          <RightNavLink
            onClick={handleSkipQuiz}
            data-autotag="product-quiz-skip-btn"
          >
            <FormattedMessage
              id="global_quiz.skip_quiz_label"
              defaultMessage="Skip Quiz"
            />
          </RightNavLink>
        ) : null}
      </RightNavButtonWrapper>
    </QuizNavBarWrapper>
  );
};

QuizNavBar.propTypes = {
  handleExit: PropTypes.func,
  handleSkipQuiz: PropTypes.func,
  previousScreen: PropTypes.func,
  navigationTextColor: PropTypes.string,
  shouldShowBackLink: PropTypes.bool,
  shouldShowCloseLink: PropTypes.bool,
  shouldShowSkipQuizLink: PropTypes.bool,
};

export default QuizNavBar;
